// Generated by Melange

import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Json from "melange-json/Json.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__Credentials from "../api/subsonic/credentials.jsx";

function make(set) {
  const credentials_local_storage_key = "subsonic-credentials";
  const clearSubsonicCredentials = function (param) {
    Curry._2(set, (function (prevState) {
      const init = prevState.auth;
      return {
        albums: prevState.albums,
        artists: prevState.artists,
        auth: {
          clearSubsonicCredentials: init.clearSubsonicCredentials,
          credentials: undefined,
          saveSubsonicCredentials: init.saveSubsonicCredentials
        },
        player: prevState.player,
        songs: prevState.songs
      };
    }), false);
    localStorage.removeItem(credentials_local_storage_key);
  };
  const saveSubsonicCredentials = function (credentials) {
    Curry._2(set, (function (prevState) {
      const init = prevState.auth;
      return {
        albums: prevState.albums,
        artists: prevState.artists,
        auth: {
          clearSubsonicCredentials: init.clearSubsonicCredentials,
          credentials: credentials,
          saveSubsonicCredentials: init.saveSubsonicCredentials
        },
        player: prevState.player,
        songs: prevState.songs
      };
    }), false);
    localStorage.setItem(credentials_local_storage_key, Stdlib__Option.get(JSON.stringify(credentials)));
  };
  const credentials = Stdlib__Option.map((function (param) {
    return Stdlib__Fun.compose(Subsonic__Credentials.of_json, Json.parseOrRaise, param);
  }), Caml_option.null_to_opt(localStorage.getItem(credentials_local_storage_key)));
  return {
    clearSubsonicCredentials: clearSubsonicCredentials,
    credentials: credentials,
    saveSubsonicCredentials: saveSubsonicCredentials
  };
}

export {
  make,
}
/* Json Not a pure module */
